// extracted by mini-css-extract-plugin
module.exports = {"cards":"staticCards_cards__GNMQ_","hide":"staticCards_hide__G3Rb8"};